import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ValueAddedFeeSettings } from './ValueAddedFeeSettings';

export class ValueAddedFeesResource extends FBaseService {
  public async getCurrentSettings(fiId: number): Promise<ValueAddedFeeSettings> {
    try {
      const response: AxiosResponse = await this.apiClient.get(
        `/api/rcx/config/${fiId}/value-added-fees-config`,
      );
      const settings: ValueAddedFeeSettings = response.data.data;
      return settings;
    } catch (error) {
      // Will 404 if ValueAddedFeeSettings has not been set up yet, so return empty settings
      if ((error as any).response.status !== 404) {
        throw error;
      } else {
        return ValueAddedFeesResource.createEmptySettings(fiId);
      }
    }
  }

  public async save(fiId: number, settings: ValueAddedFeeSettings): Promise<ValueAddedFeeSettings> {
    const url = `/api/rcx/config/${fiId}/value-added-fees-config`;
    let response: AxiosResponse;

    if (settings.id) {
      response = await this.apiClient.put(url, settings);
    } else {
      response = await this.apiClient.post(url, settings);
    }

    const savedSettings: ValueAddedFeeSettings = response.data.data;
    return savedSettings;
  }

  public static createEmptySettings(fiId: number): ValueAddedFeeSettings {
    return {
      id: null!,
      fiId,
      firstAddedFeesProcessingCoreProcessingDate: null,
      finalAddedFeesProcessingCoreProcessingDate: null,
      addedFeesProcessingEnabled: false,
    };
  }
}

export default ValueAddedFeesResource;
